export {default as globalLayout} from './lib/json/_global/layout.json'
export {default as globalOpacity} from './lib/json/_global/opacity.json'
export {default as globalShadow} from './lib/json/_global/shadow.json'
export {default as bookawayColors} from './lib/json/bookaway.json'
export {default as checkmybusColors} from './lib/json/checkmybus.json'
export {default as dealbaseColors} from './lib/json/dealbase.json'
export {default as goseekColors} from './lib/json/goseek.json'
export {default as holidaypiratesColors} from './lib/json/holidaypirates.json'
export {default as kayakColors} from './lib/json/kayak.json'
export {default as kiwiColors} from './lib/json/kiwi.json'
export {default as laylaColors} from './lib/json/layla.json'
export {default as ovagoColors} from './lib/json/ovago.json'
export {default as cssTheme} from './lib/json/theme.json'
export {default as vioColors} from './lib/json/vio.json'
export {default as wewardColors} from './lib/json/weward.json'
export {nativeColors} from './lib/ts/nativeColors'
